import React from 'react'

import { i18n } from '@zet/localization'
import {
  CustomBottomSheet,
  PrimeExpiredProps,
  useSubscriptionStore,
} from '@zet/zet-prime'

const PrimeExpired = ({
  isVisible,
  onClose,
  onSubscribe,
}: PrimeExpiredProps) => {
  const subscription = useSubscriptionStore((state: any) => state.subscription)

  const handleSubscribeNow = () => {
    if (onSubscribe) {
      onSubscribe()
    }
    onClose()
  }

  return (
    <CustomBottomSheet
      isVisible={isVisible}
      onClose={onClose}
      iconImage={require('@zet/zet-prime/assets/images/caution.png')}
      headerText={i18n.t('zetPrime.areYouSureCancelSubscription')}
      subHeaderText={i18n.t('zetPrime.ifYouCancel')}
      earningsWithZetPrime={subscription?.earnings}
      showBillingInfo={true}
      amount={'99'}
      buttons={[
        {
          text: i18n.t('zetPrime.subscribeNow'),
          onPress: handleSubscribeNow,
          variant: 'primary',
        },
      ]}
    />
  )
}

export default PrimeExpired
